import { FC, useEffect, useState } from "react";
import queryString from "query-string";
import { Text, Stack, Heading } from "@chakra-ui/react";

import Container from "components/Chakra/Container";
import SubscribeEmailingTobBoard from "utils/topBoard/api/SubscribeEmailingTobBoard";
import GetEmailingTopBoard from "utils/topBoard/api/GetEmailingTopBoard";
import { CITIES, TCity } from "utils/topBoard/types";
import { useTracking } from "contexts/Tracking";
import List from "./List";
import useCitiesEnum from "./useCitiesEnum";
import RadioWithText from "components/Chakra/RadioWithText";
import Checkbox from "components/Chakra/Checkbox";
import useRouter from "hooks/useRouter";
import useApiEndpoint from "hooks/useApiEndpoint";

const TopBoard: FC = () => {
  const { query } = useRouter();
  const { trackEvent } = useTracking();

  const { callEndpoint: postEmailingApi } = useApiEndpoint(
    SubscribeEmailingTobBoard,
  );
  const { callEndpoint: getEmailingApi } = useApiEndpoint(GetEmailingTopBoard);

  const [toggledCity, setToggledCity] = useState<TCity>(() => {
    if (
      query.city &&
      !Array.isArray(query.city) &&
      query.city.toLocaleLowerCase() in CITIES
    ) {
      return query.city.toLocaleLowerCase() as TCity;
    }

    return CITIES.brno as TCity;
  });

  const [toggleEmail, setToggleEmail] = useState<boolean | undefined>(() => {
    const parsed = queryString.parse(location.search);
    if (parsed && "enableTip" in parsed) {
      postEmailingApi({
        city: toggledCity,
        toggleValue: true,
      });

      return true;
    }

    return undefined;
  });

  useEffect(() => {
    (async () => {
      const { data } = await getEmailingApi({ city: toggledCity });
      if (data?.isEmailing) {
        setToggleEmail(data.isEmailing);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggledCity]);

  const citiesEnum = useCitiesEnum();

  const toggleBox = async (): Promise<void> => {
    trackEvent({
      "dl.eCat": "TOP_nastenka",
      "dl.eAct": `${!toggleEmail ? "zapnuto" : "vypnuto"}_upozorneni`,
      "dl.eLab": "",
    });
    const toggledValue = !toggleEmail;
    const { data } = await postEmailingApi({
      city: toggledCity,
      toggleValue: toggledValue,
    });
    if (data) {
      setToggleEmail(toggledValue);
    }
  };

  return (
    <>
      <Container>
        <Heading as="h1" mt="5rem" mb="2rem">
          TOP 12 inzerátů
        </Heading>

        <Text size="large" textAlign="center">
          Náš algoritmus porovnává celou řadu parametrů a vybírá pro vás 12
          nabídek s <b> nejlepším poměrem cena / výkon.</b>
          <br /> Buďte u pronájmů, o které se všichni perou, rychleji než
          ostatní.
        </Text>

        <Stack
          p="32px"
          mt="56px"
          bg="ud-white"
          spacing="16px"
          borderRadius="6px"
          alignItems="center"
          boxShadow="0 2px 11px 0 rgba(0, 0, 0, 0.18)"
        >
          <Stack direction="row" spacing="80px" justify="center">
            {citiesEnum.map(({ id, nominativeTranslation }) => (
              <RadioWithText
                key={id}
                onClick={() => {
                  trackEvent({
                    "dl.eCat": "TOP_nastenka",
                    "dl.eAct": "radio_click",
                    "dl.eLab": id,
                  });
                  setToggledCity(id);
                }}
                isActive={toggledCity === id}
                text={nominativeTranslation}
              />
            ))}
          </Stack>

          <Checkbox
            isChecked={toggleEmail}
            onChange={toggleBox}
            label={
              <Text>
                <b>TIP: </b> Zapněte si upozornění, ať jste u nejatraktivnějších
                inzerátů jako první.
              </Text>
            }
          />
        </Stack>
      </Container>
      <List city={toggledCity || "brno"} />
    </>
  );
};

export default TopBoard;
